import React from 'react';

export default function ReportsIcon() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 13.3333V6.66663M12 13.3333V2.66663M4 13.3333V10.6666'
        stroke='url(#paint0_linear_1658_912)'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1658_912'
          x1='3.93819'
          y1='0.474977'
          x2='12.2173'
          y2='9.57629'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0.65' />
        </linearGradient>
      </defs>
    </svg>
  );
}
